import React, { Component } from 'react';

export class Services extends Component {
  static displayName = Services.name;


  render() {
    return (
      <div>
            <div class="container-fluid bg-primary py-5 bg-header">
                <div class="row py-5">
                    <div class="col-12 pt-lg-5 mt-lg-5 text-center animated zoomIn">
                        <h3 class="text-capitalize text-white animated zoomIn">services</h3>
                        <a class="h5 text-capitalize  text-white">home</a>
                        <i class="bi bi-chevron-right text-white px-2"></i>
                        <a class="h5 text-capitalize  text-white">services</a>
                    </div>
                    <div>
                    </div>
                </div>
            </div>

            {/*our service modals start here*/}
            <div class="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">

                {/*======= service Section starts here =======*/}
                <section id="services">
                    <div class="container-xxl py-1">
                        <div class="container">
                            <div class="row g-3">
                                <div class="col-sm-12 col-md-3 col-lg-3 text-center">
                                    <p class="my-card">Networking</p>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3 text-center">
                                    <p class="my-card">IT Infrastructure</p>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3 text-center">
                                    <p class="my-card">CCTV, Alarm & Biometrics</p>
                                </div>
                                <div class="col-sm-12 col-md-3 col-lg-3 text-center">
                                    <p class="my-card">ICT consultation</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*========= service section ends here========*/}

                <div class="container py-5">
                    <div class="section-title text-center position-relative pb-3 mb-5 mx-auto">
                        <h5 class="fw-bold text-primary text-uppercase">Our Services</h5>
                        <p class="mb-0 text-uppercase fw-bold">best ICT solutions for modern businesses</p>
                    </div>

                    <div class="row g-5">

                        <div class="col-lg-3 col-md-6 wow zoomIn" data-wow-delay="0.3s">
                            <div class="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                                <div class="service-icon">
                                    <i class="bi bi-diagram-3 text-primary"></i>
                                </div>
                                <h4 class="mb-3 text-capitalize">computer networking</h4>
                                <p class="m-0">
                                    We design, deploy, and maintain secure wired and wireless networks for businesses,
                                    schools, hospitals, warehouses, and enterprise environments.
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                            <div class="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                                <div class="service-icon">
                                    <i class="bi bi-server text-primary"></i>
                                </div>
                                <h4 class="mb-3 text-capitalize">IT infrastructure</h4>
                                <p class="m-0">
                                    We implement virtualization, enterprise storage, backup and replication,
                                    server deployment, monitoring, and infrastructure management solutions.
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                            <div class="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                                <div class="service-icon">
                                    <i class="bi bi-camera-video text-primary"></i>
                                </div>
                                <h4 class="mb-3 text-capitalize">CCTV & access control</h4>
                                <p class="m-0">
                                    We install CCTV surveillance, biometric systems, and access control solutions
                                    to improve security across homes, offices, schools, and businesses.
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 wow zoomIn" data-wow-delay="1.2s">
                            <div class="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                                <div class="service-icon">
                                    <i class="bi bi-person-workspace text-primary"></i>
                                </div>
                                <h4 class="mb-3 text-capitalize">ICT consultation</h4>
                                <p class="m-0">
                                    We provide expert ICT consultation, infrastructure planning, technology assessments,
                                    deployment strategies, and ongoing technical support for organizations.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/*our service modals end here*/}


      </div>
    );
  }
}
